<template>
	<v-container :class="[corBackground]" fluid>
		<v-row
			:class="['cabecalho-pagina', 'rounded-tl', 'rounded-tr', corBackground]"
			justify="center"
			align="center"
			dense
			no-gutters
		>
			<v-col
				cols="12"
				md="7"
				class="margem d-flex flex-sm-row flex-md-row flex-lg-row flex-column flex-wrap justify-start"
			>
				<div v-for="texto in getInformacoes()" :id="texto.titulo" :key="texto.id" class="cabecalho">
					<v-list-item class="px-0">
						<v-list-item-content>
							<v-list-item-title id="titulo" class="label">
								<span :class="corTitulo" v-html="texto.titulo"></span>
								<span class="red--text" v-if="texto.isObrigatorio"> *</span>
							</v-list-item-title>
							<v-list-item-subtitle id="subtitulo" :class="['text', corSubtitulo]" v-if="!texto.isCustom">
								<texto-tooltip
									:tamanho-maximo="tamanhoSubTitulo"
									:texto="texto.subtitulo.texto"
								></texto-tooltip>
								<span class="ma-1">
									<slot :name="texto.slotName + '_icone'"></slot>
								</span>
							</v-list-item-subtitle>
							<slot :name="texto.slotName + '_editando'" v-else :texto="texto"></slot>
						</v-list-item-content>
					</v-list-item>
				</div>
				<div class="cabecalho">
					<v-list-item class="px-0">
						<slot name="bpm_activity"></slot>
					</v-list-item>
				</div>
			</v-col>
			<v-col cols="12" md="5">
				<div class="cabecalho">
					<div>
						<v-row :class="['margem', corBackground]" justify="end" class="flex-nowrap">
							<slot name="actions"></slot>
						</v-row>
					</div>
				</div>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TextoTooltip from '@/views/components/TextoTooltip'

export default {
	name: 'cabecalho-pagina',
	components: {
		TextoTooltip,
	},
	props: {
		tamanhoSubTitulo: {
			type: Number,
			default: 25,
		},
		corBackground: {
			type: String,
			default: 'primary',
		},
		corTitulo: {
			type: String,
			default: 'white--text',
		},
		corSubtitulo: {
			type: String,
			default: 'white--text',
		},
	},
	methods: {
		getInformacoes() {
			let info = this.$store.state.cabecalhoPadrao

			if (info) {
				return info.filter((item) => item.show)
			}
			return []
		},
	},
}
</script>

<style lang="stylus" scoped>
.cabecalho-pagina
	.cabecalho
		.label
			font-weight bold !important
			font-size 0.75em !important

		.text
			font-size .8em !important

.margem
	margin 0 !important
	padding: .8rem 0.5rem !important;

#subtitulo div:first-child
	float: left !important

#subtitulo-icone i
	margin-left 0.75em !important
</style>
